export {
  Section,
  type SectionProps,
} from '@tui-cruises/mein-schiff-web-react-component-library/src/components/core/Section';
